import {modules} from "@/systems/modules/modules.js";
import PlayerBansView from "@/systems/modules/punishments/bans/PlayerBansView.vue";
import settings from "@/systems/modules/settings/settings.js";
import authorization from "@/authorization";
import PunishmentsHeaderView from "@/systems/modules/punishments/PunishmentsHeaderView.vue";
import KicksView from "@/systems/modules/punishments/kicks/KicksView.vue";
import PlayerPunishmentsHeaderView from "@/systems/modules/punishments/PlayerPunishmentsHeaderView.vue";
import PlayerKicksView from "@/systems/modules/punishments/kicks/PlayerKicksView.vue";
import WarningsView from "@/systems/modules/punishments/warnings/WarningsView.vue";

export default {
    initialize() {

    },
    getRoutes: () => ([
        {
            name: "community.modules.punishments",
            path: "punishments",
            component: PunishmentsHeaderView,
            meta: {
                authorize: () => authorization.moduleEnabled(modules.punishments) && (authorization.permission("modules.punishments.bans.view") || authorization.permission("modules.punishments.kicks.view")),
            },
            redirect: { name: "community.modules.punishments.bans" },
            children: [
                {
                    name: "community.modules.punishments.bans",
                    path: "bans",
                    component: PlayerBansView,
                    props: true,
                    meta: {
                        authorize: () => authorization.permission("modules.punishments.bans.view")
                    }
                },
                {
                    name: "community.modules.punishments.warnings",
                    path: "warnings",
                    component: WarningsView,
                    props: true,
                    meta: {
                        authorize: () => authorization.permission("modules.punishments.warnings.view")
                    }
                },
                {
                    name: "community.modules.punishments.kicks",
                    path: "kicks",
                    component: KicksView,
                    props: true,
                    meta: {
                        authorize: () => authorization.permission("modules.punishments.kicks.view")
                    }
                },
                ...settings.getRoutes(modules.punishments)
            ]
        },
    ]),
    getPlayerRoutes: () => ([
        {
            name: "player.modules.punishments",
            path: "punishments",
            component: PlayerPunishmentsHeaderView,
            meta: {
                authorize: () => authorization.moduleEnabled(modules.punishments) && (authorization.permission("modules.punishments.bans.view") || authorization.permission("modules.punishments.warnings.view") || authorization.permission("modules.punishments.kicks.view")),
            },
            redirect: { name: "player.modules.punishments.bans" },
            children: [
                {
                    name: "player.modules.punishments.bans",
                    path: "bans",
                    component: PlayerBansView,
                    props: true
                },
                {
                    name: "player.modules.punishments.warnings",
                    path: "warnings",
                    component: WarningsView,
                    props: true
                },
                {
                    name: "player.modules.punishments.kicks",
                    path: "kicks",
                    component: PlayerKicksView,
                    props: true
                }
            ]
        },
    ])
};